import RedBox4 from "../../assets/images/red-box-4.png";
import WhiteBox2 from "../../assets/images/white-box-2.png";
import PurpleBox3 from "../../assets/images/purple-box-3.png";

const WhatIsDigicall = (props) => {
  return (
    <section
      id={props.currentLang === "eng" ? "what-is-digicall" : "digicall-nedir"}
      className="w-full flex justify-center bg-[url('../../assets/images/WhatIsDigicallBg.png')] bg-center bg-cover py-28 relative"
    >
      <div className="w-4/5 max-w-screen-xl text-center space-y-5 md:space-y-10 lg:space-y-16 z-[1]">
        <div data-aos="fade-down">
          {props.currentLang === "eng" ? (
            <h2 className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-[#7705BC] font-bold">
              WHAT IS <span className="whitespace-nowrap">DIGI-CALL?</span>
            </h2>
          ) : (
            <h2 className="text-3xl md:text-5xl lg:text-[3.5rem] lg:leading-[4rem] text-[#7705BC] font-bold">
              <span className="whitespace-nowrap">DIGI-CALL</span> NEDİR?
            </h2>
          )}
        </div>

        {props.currentLang === "eng" ? (
          <p
            data-aos="fade-up"
            className="text-[#1F36C7] text-sm sm:text-xl md:text-2xl leading-normal"
          >
            Are you ready to get to know the Unilever Digital team closely and
            experience the digital world with{" "}
            <span className="whitespace-nowrap">Digi-Call?</span> <br /> We will
            come together to support sustainable life and create a positive
            impact by using the power of digital in{" "}
            <span className="whitespace-nowrap">Digi-Call.</span> <br />{" "}
            <span className="font-bold">
              Apply Digi-Call and let’s explore our digital future together!
            </span>
          </p>
        ) : (
          <p
            data-aos="fade-up"
            className="text-[#1F36C7] text-sm sm:text-xl md:text-2xl leading-normal"
          >
            Unilever Digital ekibini yakından tanımaya ve{" "}
            <span className="whitespace-nowrap">Digi-Call</span> ile dijital
            dünyayı deneyimlemeye hazır mısınız?
            <br />
            <span className="whitespace-nowrap">Digi-Call'da</span> dijitalin
            gücünü kullanarak sürdürülebilir yaşamı desteklemek ve pozitif etki
            yaratmak için bir araya geleceğiz. <br />
            <span className="font-bold">
              Digi-Call'a başvur ve dijital geleceğimizi birlikte keşfedelim!
            </span>
          </p>
        )}
      </div>

      <img
        className="w-20 absolute left-10 bottom-10 animate-[wiggle_10s_ease-in-out_infinite]"
        src={RedBox4}
        alt="red box"
      />
      <img
        className="w-20 sm:w-28 absolute right-5 top-5 md:right-14 md:top-14 lg:right-24 lg:top-20"
        src={WhiteBox2}
        alt="white box"
      />
      <img
        className="absolute w-[90px] sm:w-[150px] md:w-[200px] -top-12 sm:-top-24 right-10 md:right-32 animate-[wiggle_10s_ease-in-out_infinite]"
        src={PurpleBox3}
        alt="purple box"
      />
    </section>
  );
};

export default WhatIsDigicall;
